import { render } from "./select-from-db.html?vue&type=template&id=68a1575e&scoped=true&ts=true"
import script from "./select-from-db.ts?vue&type=script&lang=ts"
export * from "./select-from-db.ts?vue&type=script&lang=ts"

import "./select-from-db.scss?vue&type=style&index=0&id=68a1575e&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a1575e"]])

export default __exports__